<template>
    <div id="legal-component">
        <b-modal v-model="showModal" hide-footer size="xl" centered scrollable :title="titleModal">
            <form id="formCrud" class="formCrud">

                <div class="row scr-gap-15-0">

                    <div class="col-4">
                        <select v-model="doctos.kind" id="">
                            <option :value="0">Tipo</option>
                            <option :value="1">Politicas</option>
                            <option :value="2">Aviso</option>

                        </select>
                    </div>
                    <div class="col-12">
                        <editor v-model="doctos.info" plugins="lists advlist"
                                toolbar="bold italic | alignleft aligncenter alignright | bullist numlist | link image media | insertdatetime | code codesample"/>
                    </div>
                    <div class="col-12">
                        <button id="dyn-button" type="button" class="formSubmit" v-on:click="guardar()">{{
                                tituloBtn
                            }}
                        </button>
                    </div>
                </div>
            </form>
        </b-modal>
        <main id="mainContent" class="padFixBoth">
            <div class="view">
                <div class="barSettings">
                    <div class="row">
                        <div class="col-md-2">
                            <button type="button" class="formSubmit" v-on:click="openModalsProviders()">{{
                                    tituloBtn
                                }}
                            </button>
                        </div>
                    </div>
                </div>
                <div class="container-fluid">
                    <div class="row">

                        <b-table responsive id="my-table" striped hover :fields="fields" :busy="isBusy"
                                 :items="pagination">
                            <!-- A virtual column -->
                            <template #cell(tipo)="{item}">
                                {{ item.kind == 1 ? 'Politicas' : 'Aviso' }}
                            </template>
                            <template #cell(Acciones)="{item}">
                                <div class="dropdown">
                                    <button class="btn btn-warning dropdown-toggle" type="button"
                                            id="dropdownMenuButton"
                                            data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        <i class="fas fa-cogs"></i>
                                    </button>
                                    <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                        <a class="dropdown-item" href="javascript:void(0)"
                                           v-on:click="modificar=true; updateReg(item)">Editar</a>
                                        <a class="dropdown-item" href="javascript:void(0)"
                                           v-on:click="onClickDelete(item.id)">Borrar</a>
                                    </div>
                                </div>
                            </template>
                            <template #table-busy>
                                <div class="text-center text-danger my-2">
                                    <b-spinner class="align-middle"></b-spinner>
                                    <strong>Loading...</strong>
                                </div>
                            </template>
                        </b-table>
                    </div>
                </div>
            </div>
        </main>
    </div>
</template>

<script>
import {myMixins} from "../mixins/myMixins";
import {legalService} from "../../Services/Legal.service";
import Editor from '@tinymce/tinymce-vue'

export default {
    name: "legal-component",
    mixins: [myMixins],
    components: {
        'editor': Editor
    },
    data() {
        return {
            show: false,
            isBusy: false,
            modificar: false,
            doctos: {
                id: 0,
                info: '',
                kind: 0,
            },
            params: {
                limit: 10,
                page: 1,
            },
            pagination: [],
            fields: [
                {
                    key: 'tipo',
                    sortable: false
                },
                {
                    key: 'Acciones',
                    sortable: false
                }
            ],
            tituloBtn: 'Agregar'
        }
    },
    methods: {
        async onClickDelete(id) {
            let resp = await legalService.deleteOne(id);
            this.getAlert(resp.process);
            await this.index();
        },
        async guardar() {
            let resp = '';
            let respVal = this.valFormulariosV3();
            if (respVal) {
                this.disableSubmitBtn(true);
                if (this.modificar) {
                    resp = await legalService.updateOne(this.doctos.id, this.doctos);
                } else {
                    resp = await legalService.saveOne(this.doctos);
                }
                this.setEmpty();
                this.getAlert(resp.process);
                await this.index();
                this.disableSubmitBtn(false);
            }
            this.modificar = false;
        },
        async index() {
            this.isBusy = true;
            this.pagination = await legalService.getMany(this.params);
            this.isBusy = false;
        },
        updateReg(data = {}) {
            if (this.modificar) {
                this.tituloBtn = 'Actualizar';
                this.doctos = data;
            } else {
                this.tituloBtn = 'Agregar';
                this.setEmpty();
            }
        },
        onChange(page) {
            this.params.page = page;
            this.index();
        },
        changeLimit() {
            this.index();
        },
        setEmpty() {
            this.doctos = {
                id: 0,
                info: '',
                kind: 0,
            };
        }
    },
    mounted() {
        this.index();
    }
}
</script>
